import api from '../../../utils/functions/api';

import {
  DISCOUNT_PAYMENT_ALL,
  DISCOUNT_PAYMENT_CREATE,
  DISCOUNT_PAYMENT_GET,
  DISCOUNT_PAYMENT_UPDATE,
  DISCOUNT_PAYMENT_DELETE,
  DISCOUNT_PAYMENT_ERROR,
} from '../types';

// faker.locale = "th"

export const getAllDiscountPayments = (params) => async (dispatch) => {
  try {
    const { name = '', size = '', page = 1 } = params;
    const { data, status } = await api.get(
      `${process.env.REACT_APP_API_URL}/discount-payment?name=${name}&size=${size}&page=${page}`,
    );
    if (status === 200) {
      dispatch({ type: DISCOUNT_PAYMENT_ALL, payload: data });
    }
  } catch (error) {
    console.error(error);
    dispatch({ type: DISCOUNT_PAYMENT_ERROR });
    throw new Error(error);
  }
};

export const getOneDiscountPayments = (id) => async (dispatch) => {
  await api
    .get(`${process.env.REACT_APP_API_URL}/discount-payment/${id}`)
    .then((res) => {
      console.log('Request Server to Get One option');
      if (res.data) {
        dispatch({ type: DISCOUNT_PAYMENT_GET, payload: res.data });
      } else {
        dispatch({ type: DISCOUNT_PAYMENT_GET, payload: null });
      }
    });
};
export const createOneDiscountPayments = (payload) => async (dispatch) => {
  await api
    .post(`${process.env.REACT_APP_API_URL}/discount-payment/`, payload)
    .then(() => {
      console.log('Request Server to Create New option');
      dispatch({ type: DISCOUNT_PAYMENT_CREATE });
    });
};

export const editOneDiscountPayments = (id, payload) => async (dispatch) => {
  await api
    .put(`${process.env.REACT_APP_API_URL}/discount-payment/${id}`, payload)
    .then(() => {
      console.log('Request Server to edit option');
      dispatch({ type: DISCOUNT_PAYMENT_UPDATE });
    });
};

export const deleteOneDiscountPayments = (id) => async (dispatch) => {
  await api
    .delete(`${process.env.REACT_APP_API_URL}/discount-payment/${id}`)
    .then(() => {
      console.log('Request Server to Delete One option');
      dispatch({ type: DISCOUNT_PAYMENT_DELETE, payload: null });
    });
};
